import Keycloak from 'keycloak-js'

const keycloakConfig = {
  url:
    process.env.REACT_APP_KEYCLOAK_URL_BASE ||
    window.REACT_APP_KEYCLOAK_URL_BASE,
  realm:
    process.env.REACT_APP_KEYCLOAK_REALM || window.REACT_APP_KEYCLOAK_REALM,
  clientId:
    process.env.REACT_APP_KEYCLOAK_CLIENT_ID ||
    window.REACT_APP_KEYCLOAK_CLIENT_ID,
}

const keycloak = new Keycloak(keycloakConfig)

const persistIdToken = () => {
  try {
    if (keycloak.idToken) {
      localStorage.setItem('id_token', keycloak.idToken)
    }
  } catch (err) {
    console.error('Error persisting id_token on localStorage', err)
  }
}

keycloak.onAuthSuccess = persistIdToken
keycloak.onAuthRefreshSuccess = persistIdToken

let initPromise

const initKeycloak = () => {
  if (!initPromise) {
    initPromise = keycloak
      .init({
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
        pkceMethod: 'S256',
        checkLoginIframe: false,
        scope: 'openid',
      })
      .then(authenticated => {
        if (authenticated) {
          persistIdToken()
        }
        return authenticated
      })
  }
  return initPromise
}

export { initKeycloak }
export default keycloak
